import tw from 'tailwind-styled-components'

const ButtonContainer = tw.div`

`
const ContainerStyle = tw.div`
relative 
max-h-[42px] 
bg-background 
rounded-md 
shadow-inputShadow 
text-left 
cursor-default 
focus:outline-none 
focus:ring-1 
sm:text-sm
border
border-inputBorder
pr-1
`

const boxButton = `
outline-none 
relative 
w-full 
h-full 
rounded-md   
text-left 
cursor-default
bg-white
`

const Icon = tw.span`
absolute 
inset-y-0 
right-4 
flex 
items-center 
pointer-events-none
`

export const inputRequiredStyle = `
border
border-errorText
`

const InputDatePicker = tw.input`
w-full
relative 
max-h-[42px] 
!bg-white
rounded-md 
shadow-inputShadow 
text-left 
cursor-default 
focus:outline-none 
focus:ring-1 
sm:text-sm
border
border-inputBorder
pr-1
`

const containerStyle = `
relative 
max-h-[42px] 
w-44
bg-inherit
rounded-md 
shadow-inputShadow 
text-left 
cursor-default 
focus:outline-none 
focus:ring-1 
sm:text-sm
text-darkGray
border
border-inputBorder
`
const inputBorderStyle = `
border
border-inputBorder
`

export {
    ButtonContainer,
    ContainerStyle,
    boxButton,
    Icon,
    containerStyle,
    inputBorderStyle,
    InputDatePicker
}
